import React, { useMemo, useCallback, useTransition } from "react";
import DownLtLogoBlue from "@svgIcons/DownIt";
import menuItemData from "@/data/menu-items.json";
import styles from "./desktop-menu.module.scss";
import { usePathname } from "next/navigation";
import { GAEvent, GA_EVENTS, GA_EVENTS_PAYLOAD } from "@/helpers/gaEvents";
import { pushToDataLayer } from "@/helpers/gtag";
import { getGlobalStateValue } from "@/context/utils";

const { NAVIGATION_CLICK } = GAEvent;
interface MenuItem {
  enabled: boolean;
  Item: {
    text: string;
    url?: string;
    target?: string;
    title?: string;
    isHover?: boolean
  };
  SubItem?: Array<unknown>;
}

const MenuItemComponent: React.FC<{
  item: MenuItem;
  onClick: () => void;
  onHover: () => void;
  isMenuOpen: boolean;
  
}> = React.memo(({ item, onClick, isMenuOpen, onHover }) => {
  const pathname = usePathname();
  const handleClick = (item) => {
    onNavigateHandler(item);
    onClick();
  };
  const onNavigateHandler = (item) => {
    const payload = {
      cta_text: item.Item?.text || "",
      category: item.Item?.title || "",
      sub_category: "NA",
      section_name: "header",
      redirection_url: item.Item?.url || "",
      header_title: "NA",
    };
    const heading = item.Item.text;

    setTimeout(() => {
      if (typeof window !== "undefined") {
        const gaData = GA_EVENTS.get(NAVIGATION_CLICK);
        pushToDataLayer({
          ...gaData,
          ...payload,
          page_type: getGlobalStateValue("pageType") || "Home Page",
        });

        if (heading == "CAREER SERVICES") {
          window?.webengage?.track("Career Advice Clicked");
        } else if (heading == "PROGRAMS") {
          window?.webengage?.track("Programs Clicked");
        }
      }
    }, 1500);
  };

  if (item.Item.url) {
    return (
      <a
        onClick={() => onNavigateHandler(item)}
        target={"_self"}
        href={item.Item.url}
        className={`${styles.dMenuItem} ${
          item.Item.url == pathname && !isMenuOpen ? styles.dMenuItemActive : ""
        }`}
        aria-label={`${item.Item.text}`}
        id="career-services-btn"
      >
        {item.Item.text}
        {!!item.SubItem?.length && <DownLtLogoBlue color={"#fff"} strokeWidth={"2"}/>}
      </a>
    );
  }
  const isHoverEnabled = !!item.Item?.isHover;
  return (
    <div
      className={`${styles.dMenuItem} ${
        isMenuOpen ? styles.dMenuItemActive : ""
      }`}
      {...(isHoverEnabled
        ? {
            onMouseOver: onHover,
          }
        : {
            onClick: () => handleClick(item),
          })}
      id = "program-menu"
      aria-label={`${item.Item.text}`}
      onKeyDown={(e) => e.key === "Enter" && handleClick(item)}
    >
      {item.Item.text}
      {!!item.SubItem?.length && <DownLtLogoBlue color={"#fff"} strokeWidth={"2"}/>}
    </div>
  );
});

const DMenuItems = ({ setIsMenuItem, isMenuOpen }) => {
  const [, startTransition] = useTransition();

  const onMenuItemClick = (isMenuOpen, index) => {
    startTransition(() => {
      setIsMenuItem(index == 0 ? !isMenuOpen : false);
    });
  };

  const onMenuHoverClick = () => {
    startTransition(() => {
      setIsMenuItem(true);
    });
  };

  const filteredMenuItems = useMemo(() => {
    
    return menuItemData
      .filter((item) => item.enabled)
      .map((item, index) => (
        <MenuItemComponent
          key={index}
          item={item}
          onClick={() => onMenuItemClick(isMenuOpen, index)}
          onHover={onMenuHoverClick}
          isMenuOpen={isMenuOpen}
          
        />
      ));
  }, [isMenuOpen]);

  return <div className={styles.dMenuItemWrapper}>{filteredMenuItems}</div>;
};
export default DMenuItems;
